// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@conklin/XDL/Utilities";
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.badgeImageWrapper = {
    css: css`
        height: 23px;
        max-height: 23px;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

productImageStyles.badgeTextWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            &&& {
                position: static;
                margin-top: 8px;
            }
        }
    `,
};

productImageStyles.badgeText = {};

productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: fit-content;
        &.center {
            margin: 0 auto;
        }
    `,
};

productImageStyles.compareCheckbox = {
    css: css`
        align-self: left;
    `,
};
